
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from 'src/app/shared/services/generic.service';


@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.scss']
})
export class PesquisaComponent implements OnInit {
  
  data: any[];
  palavrachave: String ="";
  constructor(private route: ActivatedRoute,private router: Router,
    private genericService: GenericService) { }

  ngOnInit(): void {
   
    this.route.params.subscribe(routeParams => {
   
      if(routeParams.palavrachave)
      this.palavrachave = routeParams.palavrachave;

     
    })

    this.getData();
  }

  procurar(){
    if(this.palavrachave.length>2){
   //   console.log(this.palavrachave)
      this.router.navigateByUrl('/pesquisa/'+this.palavrachave)
    }
  }


  getData() {
    var params = new HttpParams()
      .set('whichUrl', 'Redes Sociais')
    this.genericService.getGenericMultiSearch(params).subscribe(result => {
      this.data = result;
    })
  }

  getRedeSocialLink(rede: string): string {
    return this.data?.find(x => x.Categoria == rede)?.link?.Url;
  }

}
